import { faFile } from '@fortawesome/pro-light-svg-icons/faFile'
import { faImage } from '@fortawesome/pro-light-svg-icons/faImage'
import Button from '@hotmart/space-lib/dist/components/button'
import i18n from 'src/i18n'
import clsx from 'clsx'
import { RiDeleteBinFill } from '@remixicon/react'
import Icon from '../Icon'
import { CommentType } from '../postComments'
import {
  MediaContent,
  MediaDetails,
  MediaImage,
  MediaInfo,
  MediaName,
  Wrapper
} from './mediaCard.styles'
import { MediaCardProps } from './mediaCard.types'

const MediaCard = ({
  name,
  size,
  extension,
  mediaType,
  thumbnailUrl,
  pagesCount,
  orientation,
  className,
  onClick,
  onDelete
}: MediaCardProps) => {
  const showThumbnailUrl = thumbnailUrl && mediaType !== CommentType.DOCUMENT
  const icons = {
    [CommentType.DOCUMENT]: faFile,
    [CommentType.IMAGE]: faImage
  }

  const icon = mediaType ? icons[mediaType] : undefined
  const pagesCountText =
    pagesCount === 1
      ? i18n.t('comment_media.page_one', { count: pagesCount })
      : i18n.t('comment_media.page_other', { count: pagesCount })

  const fileSize = new Intl.NumberFormat('en', {
    notation: 'compact',
    style: 'unit',
    unit: 'byte',
    unitDisplay: 'narrow'
  }).format(size)

  const getFileExtension = (fileName?: string) => {
    return extension || fileName?.replace(/(.+\.)([a-z]{3,4})$/i, '$2')
  }

  const handleClick = () => {
    onClick?.(thumbnailUrl)
  }

  const handleRemove = (event: React.MouseEvent) => {
    event.stopPropagation()
    onDelete?.(name)
  }

  return (
    <Wrapper
      orientation={orientation}
      className={clsx(
        '_d-flex _flex-1 _border _border-gray-200 _rounded-lg _overflow-hidden',
        className,
        {
          '_cursor-pointer': onClick
        }
      )}
      data-test="media-card"
      onClick={handleClick}
    >
      {showThumbnailUrl && (
        <MediaImage className="_bg-gray-200">
          <img src={thumbnailUrl} alt={name} loading="lazy" />
        </MediaImage>
      )}

      <MediaContent className="_d-flex _flex-1 _align-items-center _px-3">
        {icon && <Icon icon={icon} />}

        <MediaInfo className="_d-flex _flex-column">
          <MediaName className="_text-1 _text-gray-900 _font-weight-bold">{name}</MediaName>

          <MediaDetails className="_d-flex _text-1 _text-gray-500">
            {pagesCount && <span className="_d-flex _position-relative">{pagesCountText}</span>}
            <span className="_d-flex _position-relative">{fileSize}</span>
            <span className="_d-flex _text-uppercase">{getFileExtension(name)}</span>
          </MediaDetails>
        </MediaInfo>

        {onDelete && (
          <Button type="button" variation="tertiary" className="_ml-auto" onClick={handleRemove}>
            <span className="_sr-only">{i18n.t('comments.button_delete')}</span>
            <RiDeleteBinFill size={24} />
          </Button>
        )}
      </MediaContent>
    </Wrapper>
  )
}

export default MediaCard
